import { getCookie } from '@/util/util'
import ajax from '@/api/ajax'

export function jump(config, isBlank = false) {
    if (!getCookie('loginUser')) {
        location.replace(config.owfUrl)
    }

    // 获取ticket跳转到cx页面
    ajax.getTicket({
        params: {
            ts: new Date().getTime()
        }
    })
        .then(res => {
            if (res.data.code === 0) {
                const ticket = res.data.result
                if (isBlank) {
                    setTimeout(() => {
                        // 加宏任务解决ios下打不开链接bug
                        window.open(`${config.cxUrl}&ticket=${ticket}`)
                    })
                } else {
                    location.replace(`${config.cxUrl}&ticket=${ticket}`)
                }
            } else {
                location.replace(config.owfUrl)
            }
        })
        .catch(res => {
            location.replace(config.owfUrl)
        })
}



// WEBPACK FOOTER //
// ./src/mixins/pageJump/index.js